import { Box, Button, IconButton, Typography, useTheme } from '@mui/material'
import React, { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Delete } from '@mui/icons-material'
import { toast } from 'react-toastify'
import { observer } from 'mobx-react'
import { useEffect } from 'react'
import { useState } from 'react'

import AddResumeTemplateDialog from '../../../components/admin/resume-builder/AddResumeTemplateDialog'
import DataLoadingSpinner from '../../../components/common/DataLoadingSpinner'
import CustomTable from '../../../components/common/custom-table/CustomTable'
import { useResumeBuilderStore } from '../../../store/resumebuilder.store'
import BlockMessage from '../../../components/common/BlockMessage'
import noFormImg from '../../../assets/no-resume-templates.svg'
import CustomChip from '../../../components/common/CustomChip'
import { useUserStore } from '../../../store/user.store'
import { Icons } from '../../../utils/utilities'
import api from '../../../service/api'


const ResumeTemplates = observer( () => {

    const [loading, setLoading] = useState( true )
    const [addDialogState, setAddDialogState] = useState( false )
    const [hasPermission, setHasPermission] = useState( true )

    const ResumeBuilderStore = useResumeBuilderStore()
    const UserStore = useUserStore()

    const { table, layout, border } = useTheme()

    const navigate = useNavigate()

    const deleteTemplate = useCallback( async ( id ) => {
        try {
            await api.deleteResumeTemplate( id )
            await ResumeBuilderStore.fetchTemplates()
        } catch ( err ) {
            console.log( err )
            toast( ( err.response && err.response.data ) ? err.response.data.message : "Something went wrong!" )
        }
    }, [ResumeBuilderStore] )


    const columns = useMemo( () => [
        { name: "Template name", field: "name", padding: "10px 20px" },
        { name: "Form name", field: "form_name", padding: "10px 20px" },
        {
            name: "Institutes linked", field: "institute", renderCell: row => ( <Box display="flex" flexWrap="wrap" gap="5px">
                {row.access_list.map( institute => <CustomChip value={institute} key={institute} /> )}
            </Box> ), padding: "10px 20px"
        },
        {
            name: "Actions", align: "right", field: "actions", renderCell: row => ( <IconButton
                size="small"
                onClick={event => {
                    event.stopPropagation()
                    deleteTemplate( row.id )
                }}
            >
                <Delete sx={{ fontSize: "18px" }} />
            </IconButton> ), padding: "10px 20px"
        },
    ], [deleteTemplate] )

    useEffect( () => {
        const getData = async () => {
            await ResumeBuilderStore.fetchTemplates()
            setLoading( false )
        }
        if ( UserStore.getUser.user_role === 'SUBADMIN' && !UserStore.getUser.user_permissions.resume_builder ) {
            setHasPermission( false )
        } else
            getData()
    }, [ResumeBuilderStore, UserStore] )

    return (
        hasPermission ? <Box flexGrow={1} padding={layout.pagePadding} display="flex" flexDirection="column" overflow="auto">
            <AddResumeTemplateDialog state={addDialogState} setAddDialogState={setAddDialogState} />
            <Box sx={{ display: "flex", flexDirection: "column", gap: layout.sectionsGap }}>
                <Box display="flex" alignItems="center" gap="20px">
                    <Box flexGrow={1}>
                        <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Resume templates</Typography>
                        <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>Manage resume templates here</Typography>
                    </Box>
                    {!loading && <Button disableElevation sx={{ textTransform: "capitalize" }} onClick={() => setAddDialogState( true )} variant="contained" startIcon={Icons.default.AddIcon}>Create</Button>}
                </Box>

                {!loading && ResumeBuilderStore.getTemplates.length > 0 && <CustomTable dataIdKey="id" onRowClick={row => navigate( `/admin/resume-templates/${row.id}` )} pageSize={50} columns={columns} data={ResumeBuilderStore.getTemplates} />}

                {!loading && ResumeBuilderStore.getTemplates.length === 0 && <Box flexGrow={1} justifyContent="center" bgcolor="#eee" padding="20px" display="flex" flexDirection="column" gap="20px" alignItems="center">
                    <img src={noFormImg} height="150px" style={{ marginBottom: "20px" }} alt="No Form" />
                    <Typography color="textSecondary" variant='subtitle2'>Seems like there are no templates to show!</Typography>
                    <Button sx={{ textTransform: "capitalize" }} startIcon={Icons.default.AddIcon} onClick={() => setAddDialogState( true )} variant='outlined'>Add Template</Button>
                </Box>}
                {loading && <DataLoadingSpinner waitingMessage="Loading resume templates..." />}
            </Box>
        </Box> :
            <Box padding="20px">
                <BlockMessage message={<span>You doesn't have permission to access this page! please contact <i>Alive co-ordinators</i> for further information.</span>} type="error" />
            </Box>
    )
} )

export default ResumeTemplates
